import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import lessonActions from 'common.components/lesson/actions';
import { SpecCourseLessonViewStubButton } from 'common.components/spec-course-lesson-view/__stub-button/spec-course-lesson-view__stub-button';
import { SpecCourseLessonViewStubDescription } from 'common.components/spec-course-lesson-view/__stub-description/spec-course-lesson-view__stub-description';
import { SpecCourseLessonViewStubTitle } from 'common.components/spec-course-lesson-view/__stub-title/spec-course-lesson-view__stub-title';
import { SpecCourseLessonViewStub } from 'common.components/spec-course-lesson-view/__stub/spec-course-lesson-view__stub';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';
import { YM_LOCATION } from 'utils/ym-constants';

import './lesson-view__stub.scss';

export const SpecCourseLessonViewStubNoStudents = () => {
    const dispatch = useDispatch();
    // @ts-ignore
    const { courseId, clessonId } = useParams();

    const showAddStudentsModal = useCallback(() => {
        dispatch(
            teamBuilderActions.start({
                entryPoint: TEAM_BUILDER_ENTRY_STEPS.STUDENTS,
                onSuccess: (addedStudentsIds?: number[]) => {
                    dispatch(
                        lessonActions.finishAddingStudentsRequest({
                            studentsIds: addedStudentsIds || null,
                            ymLocation: YM_LOCATION.OLYMP,
                        })
                    );
                    dispatch(lessonActions.getClessonResultsRequest({ cLessonId: clessonId, courseId }));
                },
            })
        );
    }, [clessonId, courseId, dispatch]);

    return (
        <SpecCourseLessonViewStub mix="spec-course-lesson-view__stub-wrapper">
            <SpecCourseLessonViewStubTitle id="specCourse.LessonView.stub.noStudents.title" />
            <SpecCourseLessonViewStubDescription id="specCourse.LessonView.stub.noStudents.description" />
            <SpecCourseLessonViewStubButton
                mix="qa_spec-course-button_status-add_students"
                onClick={showAddStudentsModal}
                textId="specCourse.LessonView.stub.noStudents.button"
            />
        </SpecCourseLessonViewStub>
    );
};
